    <template>
        <div>
            <div class="col-12 mt-3">
                <div class="d-flex align-items-start align-items-lg-center justify-content-between flex-column flex-lg-row gap-2 gap-lg-5 mb-3 p-2 filter-wrapper rounded-lg p-3">
                    <size-filters
                        :formatted-options="formattedOptions"
                        :most-popular="sizeOptions?.most_popular || []"
                        :size-options="sizeOptions"
                    ></size-filters>
                    <toggle-range-route
                        :home-delivery="this.homeDelivery"
                        @rangeRouteToggled="filterTyres"
                    ></toggle-range-route>
                </div>
            </div>
            <div class="col-12">
                <h2 class="h3">Find your Size</h2>
                <new-brand-tyre-range-tyres
                    class="my-3"
                    :tyres="formattedTyres"
                    :brand="brandDetails"
                    :banners="updatedTyreCardBanners"
                    :basket="updatedBasket"
                    :home-delivery="this.homeDelivery"
                    @modalOpen="openModal()"
                    @basketUpdated="basketUpdated"
                ></new-brand-tyre-range-tyres>
            </div>
            <teleport to="body">
                <basket-modal :basket="updatedBasket" :size-options="sizeOptions" :modal-open="modalOpen" @closeModal="modalOpen = false" @basketUpdated="basketUpdated"></basket-modal>
                <upsell-modal :current-tyre="currentTyre" :upsold-tyre="upsoldTyre" :upsell-details="upsellDetails" :upsell-modal-open="upsellModalOpen" @closeModal="upsellModalOpen = false"></upsell-modal>
                <info-modal></info-modal>
            </teleport>
        </div>
</template>

<script>
    import url_filters from '@shared/mixins/url_filters';
    import basket from '@shared/mixins/basket';

    export default {
        props: [
            'brandDetails',
            'tyreRange',
            'tyres',
            'homeDeliverySession',
            'basket',
            'sizeOptions',
            'banners',
            'tyreCardBanners',
            'tyreImagePath',
            'brandImagePath',
            'siteName'
        ],
        mixins: [url_filters, basket],
        emits: ['tyresUpdated'],
        data() {
            return {
	            updatedBasket: this.basket,
                modalOpen: false,
                //There are multiple homeDelivery variations within these components, all are required sadly.
                homeDelivery: (this.homeDeliverySession == 1 ? true : false),
                updatedTyres: this.tyres,
                updatedTyreCardBanners: this.tyreCardBanners || [],
                selectedSizes: {
                    width: '',
                    profile: '',
                    diameter: '',
                    speed: ''
                },
                bannerUrl: this.banners[0] != null ? this.banners[0].brand_mobile_image_url : null,
				basketEmptied: false
            }
        },
        mounted() {
			//removes loading placeholder - fixes CLS issue
			document.querySelector('#loadingPlaceholder').style.display = 'none';

            this.emitter.on('basketEmptied', data => {
                this.basketEmptied = true;
            });
        },
        methods: {
            openModal() {
	        	this.modalOpen = true;
	        },
            basketUpdated: function(data) {
                this.updatedBasket = data;
            },
            tyresUpdated: function(data) {
                this.updatedTyres = data;
            },
            filterTyres: function(data) {
                if(typeof(data) !== 'undefined')
                {
                    this.homeDelivery = data;
                }
                this.getTyreRangeTyres(this.homeDelivery, this.tyreRange.id, this.brandDetails.id, this.selectedSizes);

                //Empty basket products once route has been changed
                if(this.updatedBasket.products) {
                    if(Object.keys(this.updatedBasket.products).length > 0) {
                        this.updatedBasket.products.splice(0);
                        this.emitter.emit('basketEmptied');
                    }
                }
            },
        },
        computed: {
            formattedOptions: function() {
                return [
                    { label: 'Width', name: 'width', data: this.sizeOptions.width },
                    { label: 'Profile', name: 'profile', data: this.sizeOptions.profile },
                    { label: 'Rim', name: 'diameter', data: this.sizeOptions.rim },
                    { label: 'Speed', name: 'speed', data: this.sizeOptions.speed },
                    // { label: 'Load', name: 'load', data: this.sizeOptions.load_index },
                ]
            },
            formattedTyres() {
                var vm = this;
                var tyres = this.updatedTyres;

                //This is necessary as the shared tyre component brand/tyre image urls are specific.
                _.forEach(tyres, function(tyre, key) {
                    tyre['brand_image_url'] = vm.brandImagePath + vm.brandDetails.image;
                    tyre['image_url'] = vm.tyreImagePath + tyre.graphic;
                });

                return tyres;
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>